"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _Form = _interopRequireDefault(require("./Form"));

var _lib = require("./lib");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-props-no-spreading */
var StripeWrapper = function StripeWrapper(_ref) {
  var onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      apiQuery = _ref.apiQuery,
      onPaymentActionSuccess = _ref.onPaymentActionSuccess,
      onPaymentActionFail = _ref.onPaymentActionFail,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      isStripeLoading = _useState[0],
      setIsStripeLoading = _useState[1];

  var elements = (0, _reactStripeJs.useElements)();
  var stripe = (0, _reactStripeJs.useStripe)();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      var intent, _yield$confirmCardPay, error, paymentIntent;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.addressFirstLine = e.addressFirstLine.replace("\n", " ");

              if (!(!stripe || !elements)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              setIsStripeLoading(true);
              _context.prev = 4;
              _context.next = 7;
              return (0, _lib.getPaymentIntent)(apiQuery, e);

            case 7:
              intent = _context.sent;
              _context.next = 10;
              return (0, _lib.confirmCardPayment)(e, stripe, intent, elements);

            case 10:
              _yield$confirmCardPay = _context.sent;
              error = _yield$confirmCardPay.error;
              paymentIntent = _yield$confirmCardPay.paymentIntent;
              setIsStripeLoading(false);

              if (!paymentIntent) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", onPaymentActionSuccess.action());

            case 16:
              return _context.abrupt("return", onPaymentActionFail.action(error));

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](4);
              // Server error handling
              setIsStripeLoading(false);
              onPaymentActionFail.action(_context.t0);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 19]]);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: _lib.initialValues,
    validationSchema: _lib.validation,
    onSubmit: handleSubmit
  }, function (props) {
    return /*#__PURE__*/_react["default"].createElement(_Form["default"], (0, _extends2["default"])({
      isLoading: isStripeLoading,
      submitContent: onSubmit,
      cancelContent: onCancel
    }, props), children);
  });
};

var _default = StripeWrapper;
exports["default"] = _default;